module.exports = "/_next/static/resources/single-bb9a38d1991ac4e009d760fc1ee4281f.jpg";